<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="13"
    viewBox="0 0 21 13"
    fill="none"
  >
    <path
      d="M20.4662 3.00518C20.6421 2.89945 20.7498 2.70748 20.7498 2.50031C20.7498 2.29315 20.6421 2.10118 20.4664 1.99545L17.284 0.0819995C17.1051 -0.0254492 16.8832 -0.0274564 16.7026 0.0771286C16.5221 0.181426 16.4105 0.375979 16.4105 0.586865V1.43958L1.3287 1.43958C1.00923 1.43958 0.750215 1.70233 0.750215 2.0264L0.750215 2.97424C0.750215 3.2983 1.00923 3.56105 1.3287 3.56105L16.4105 3.56105V4.4132C16.4105 4.62408 16.522 4.81864 16.7026 4.92293C16.8832 5.02752 17.1051 5.02551 17.2839 4.91806L20.4662 3.00518Z"
    />
    <path
      d="M1.03371 11.0052C0.85788 10.8995 0.750122 10.7075 0.750122 10.5003C0.750122 10.2932 0.85788 10.1012 1.03357 9.99545L4.21591 8.082C4.39485 7.97455 4.61672 7.97254 4.79735 8.07713C4.97784 8.18143 5.08942 8.37598 5.08942 8.58687V9.43958L20.1712 9.43958C20.4907 9.43958 20.7497 9.70233 20.7497 10.0264V10.9742C20.7497 11.2983 20.4907 11.5611 20.1712 11.5611L5.08942 11.5611V12.4132C5.08942 12.6241 4.97799 12.8186 4.79736 12.9229C4.61672 13.0275 4.39485 13.0255 4.21605 12.9181L1.03371 11.0052Z"
    />
  </svg>
</template>
